import jsPDF from "jspdf";
import { KulionerMerchantReceiptSectionProps, KulionerReceiptSectionProps, PDFDocument } from "./types";
import { createDocumentState, splitMerchantProducts } from "./utils";
import { renderContactInfo } from "./sections/contact-info";
import { renderHeader } from "./sections/header";
import { renderMerchantRecipient } from "./sections/merchant-recipient";
import { renderTable } from "./sections/table";
// import { renderFooter } from "./sections/footer";
import { KulionerMerchant, KulionerOrder, KulionerProduct } from "@/domain/entities/Kulioner";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { renderMerchant } from "./sections/merchant";

let currentReceiptStartPage = 2; // first page is empty and will be delete after generation completed
let importLogo: any;
let doc: PDFDocument | any;

const generateReceipt = async (data: KulionerOrder): Promise<void> => {
  const role = AccountController.accountData.account_type_detail?.type;
  try {
    importLogo = await import(`@/app/ui/assets/images/logo-${role}.png`);
  } catch (error) {
    console.warn(`Failed to load logo ${role}`);
  }

  
  doc.addPage();
  currentReceiptStartPage = doc.internal.getNumberOfPages();

  const state = createDocumentState();
  const { x, y } = state;
  const pageWidth = doc.internal.pageSize.getWidth();


  const finalY = renderHeader(
    new KulionerReceiptSectionProps({
      doc,
      x,
      y,
      pageWidth,
      data,
      importLogo,
    })
  );

  state.startYTable = finalY;


  await renderTable(doc, state.startYTable, data);

  currentReceiptStartPage = doc.internal.getNumberOfPages() + 1;
};

const generateTableMerchant = async (data: KulionerMerchant, isNoHeader: boolean, totalItem: number, totalPrice: number): Promise<void> => {
  doc.addPage();
  currentReceiptStartPage = doc.internal.getNumberOfPages();

  const state = createDocumentState();
  const { x, y } = state;
  const pageWidth = doc.internal.pageSize.getWidth();

  renderMerchant(
    new KulionerMerchantReceiptSectionProps({
      doc,
      x,
      y,
      pageWidth,
      data,
      isNoHeader,
      totalItem,
      totalPrice
    })
  );

  currentReceiptStartPage = doc.internal.getNumberOfPages() + 1;
};

const generateReceiptMerchant = async (data: KulionerMerchant): Promise<void> => {
  const totalItem = data.products.reduce((sum: any, item: KulionerProduct) => sum + item.quantity, 0);
  const totalPrice = data.products.reduce((sum, item) => {
    return sum + (item.price * item.quantity);
  }, 0);

  if (data.products.length > 12 ) {
    const newData = splitMerchantProducts([data], 12)

    for (const [index, merchant] of newData.entries()) {
      await generateTableMerchant(merchant, index > 0, totalItem, totalPrice)
    }
  } else {
      await generateTableMerchant(data, false, totalItem, totalPrice);
  }
};


const generateKulionerReceipt = async (data: KulionerOrder[], isMerchant = false) => {
  try {
    MainAppController.showLoading();
    doc = new jsPDF("p", "mm", "a6", true) as PDFDocument;

    // Generate semua receipt secara sequential
    if (isMerchant) {
      for (const merchant of data[0].merchants) {
        await generateReceiptMerchant(merchant);
      }
    } else {
      for (const order of data) {
        await generateReceipt(order);
      }
    }

    // Hapus halaman kosong pertama yang tadi dibuat
    doc.setPage(doc.internal.getNumberOfPages());
    doc.deletePage(1);

    doc.setProperties({
      title: "Kulioner Receipt",
    });

    doc.autoPrint();

    // Buka PDF di tab baru
    const output = doc.output("bloburl");
    window.open(output, "_blank");
    // URL.revokeObjectURL(output); // komentar dulu supaya bisa download
  } catch (error) {
    console.error("Error generating PDF Kulioner:", error);
  } finally {
    MainAppController.closeLoading();
  }
};

export const generateSingleMerchantReceipt = async (
  data: KulionerMerchant
): Promise<void> => {
  doc = new jsPDF("p", "mm", "a6", true) as PDFDocument;

  await generateReceiptMerchant(data);

  doc.setPage(doc.internal.getNumberOfPages());
  doc.deletePage(1);
  doc.setProperties({
    title: "Kulioner Receipt",
  });
  doc.autoPrint();
  const output = doc.output("bloburl");
  window.open(output, "_blank");
};


export default generateKulionerReceipt;
